import React from 'react';

import instagramPostPreview from 'src/assets/starterDashboardV2/readyToShare/instagramPostPreview.png';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { InstagramPostComponentsProps } from './types';

// TODO: This is a placeholder for development. Once this is released to prod we need to only use the provided image URL.
const defaultPreviewImageUrl = instagramPostPreview;

export function Body(props: InstagramPostComponentsProps): React.JSX.Element {
	const { loading, size } = props;

	const bodyStyles = BodyStyles({ size });

	if (loading) {
		return (
			<SkeletonContainer loading={loading} className={bodyStyles} data-testid="empty-container">
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" src={defaultPreviewImageUrl} className={bodyStyles} alt="" aria-hidden />;
}
